import { AuthContext } from '@/hooks/auth.hook';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import {
  getProfileUser,
  watchLoggedIn,
  watchProfileLoading
} from '@/redux/slices/auth.slice';
import { ReactNode, useEffect } from 'react';
import { LocalTestLoginModal } from '@/components/modals/local-test-login.modal';

const isLocalTest = import.meta.env.VITE_LOCAL_TEST === 'true';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(watchLoggedIn);
  const profileLoading = useAppSelector(watchProfileLoading);

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(getProfileUser());
    }
  }, [dispatch, isAuthenticated]);

  const showLocalTestModal = isLocalTest && !isAuthenticated && !profileLoading;

  return (
    <AuthContext.Provider value={{ isLoggedIn: isAuthenticated }}>
      {children}
      <LocalTestLoginModal open={showLocalTestModal} />
    </AuthContext.Provider>
  );
};
